import { render } from "./AnnotatedImage.vue?vue&type=template&id=58df118a&scoped=true"
import script from "./AnnotatedImage.vue?vue&type=script&lang=js"
export * from "./AnnotatedImage.vue?vue&type=script&lang=js"

import "./AnnotatedImage.vue?vue&type=style&index=0&id=58df118a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58df118a"]])

export default __exports__